import { useEffect } from 'react';
import { onModalClose } from '../helpers';
import { emailSharingTypes } from '../config';

export const VtoEventsNames = {
  VTO_GENERIC_EVENT_CLOSED: 'vto-generic-event-closed',
  VTO_PRODUCT_EVENT_EXPERIENCE_LOADED: 'vto-product-event-experience-loaded',
  VTO_GENERIC_EVENT_CAMERA_OPEN: 'vto-generic-event-camera-open',
  VTO_GENERIC_EVENT_REMOVE_COLOUR: 'vto-generic-event-remove-colour',
  VTO_GENERIC_EVENT_PHOTO_SAVED: 'vto-generic-event-photo-saved',
  VTO_ERROR_CAMERA_FAILED: 'vto-error-camera-failed',
  VTO_GENERIC_EVENT_CONSENT_SHOWED: 'vto-generic-event-consent-showed',
  VTO_GENERIC_EVENT_CONSENT_AGREED: 'vto-generic-event-consent-agreed',
  VTO_GENERIC_EVENT_ICON_KEY_VIEW_CLOSED:
    'vto-generic-event-icon-key-view-closed',
  VTO_PRODUCT_EVENT_SLIDER_COMPARE: 'vto-product-event-slider-compare',
  VTO_PRODUCT_EVENT_SLIDER_COMPARE_CLOSED:
    'vto-product-event-slider-compare-closed',
  VTO_GENERIC_EVENT_PHOTO_TAKEN: 'vto-generic-event-photo-taken',
  VTO_ERROR_NO_HAND_DETECTED: 'vto-error-no-hand-detected',
  VTO_GENERIC_EVENT_ICON_KEY_BTN_CLICKED:
    'vto-generic-event-icon-key-btn-clicked',
  SPLIT_FOUR_WAY: 'split-four-way',
  SPLIT_FOUR_WAY_CLOSED: 'split-four-way-closed',
  VTO_PRODUCT_EVENT_SHADE_SELECT: 'vto-product-event-shade-select',
  VTO_PAGE_IMPRESSION: 'vto-page-impression',
  VTO_GENERIC_EVENT_GET_STARTED: 'vto-generic-event-get-started',
  VTO_GENERIC_EVENT_SELECT_LINE: 'vto-generic-event-select-line',
  VTO_GENERIC_EVENT_FILTER_APPLY: 'vto-generic-event-filter-apply',
  VTO_GENERIC_EVENT_FILTER_RESET: 'vto-generic-event-filter-reset',
  VTO_PRODUCT_EVENT_SHOP_NOW: 'vto-product-event-shop-now',
  VTO_GENERIC_EVENT_FILTER_SELECT: 'vto-generic-event-filter-select',
  VTO_GENERIC_EVENT_SELECT_FILTER_OPEN: 'vto-generic-event-select-filter-open',
  VTO_SHARE_EMAIL: 'vto-share-email',
  VTO_SHARE_EMAIL_CONFIRM: 'vto-share-email-confirm',
  VTO_SHARE_EMAIL_SEND: 'vto-share-email-send',
  VTO_DOWNLOAD_PICTURE: 'vto-download-picture',
  VTO_DOWNLOAD_PICTURE_DOWNLOAD: 'vto-download-picture-download',
  PRODUCT_TRY_ON: 'product-try-on',
};

export const useEvents = ({
  setIsModalOpen,
  setShowStartHero,
  setIsVtoLoaded,
  setIsVtoOpened,
  vtoScriptLoaded,
  vtoActualProductSku,
  currentBreakpoint,
  eventHandler,
  setIsEmailSharingOpen,
  setIsDownloadPictureOpen,
}) =>
  useEffect(() => {
    let closed;
    let loaded;
    let launcherPageEntered;
    let opened;
    let cameraOpened;
    let reset;
    let photoSaved;
    let cameraFailed;
    let consentUIShowed;
    let consentUpdated;
    let iconKeyModalCloseBtnClicked;
    let compare;
    let compareDisabled;
    let photoTaken;
    let noHandDetected;
    let splitFourWay;
    let splitFourWayDisabled;
    let shareImage;

    if (window && window.YMK) {
      closed = window.YMK.addEventListener('closed', () => {
        onModalClose();

        setIsModalOpen(false);
        setShowStartHero(true);
        setIsVtoLoaded(false);
        setIsVtoOpened(false);

        eventHandler({ eventName: VtoEventsNames.VTO_GENERIC_EVENT_CLOSED });
      });

      loaded = window.YMK.addEventListener('loaded', () => {
        setIsVtoLoaded(true);

        eventHandler({
          eventName: VtoEventsNames.VTO_PRODUCT_EVENT_EXPERIENCE_LOADED,
        });
      });

      launcherPageEntered = window.YMK.addEventListener(
        'launcherPageEntered',
        () => {
          setIsVtoLoaded(false);
        }
      );

      opened = window.YMK.addEventListener('opened', () => {
        setIsVtoOpened(true);
      });

      cameraOpened = window.YMK.addEventListener('cameraOpened', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_GENERIC_EVENT_CAMERA_OPEN,
        });
      });

      reset = window.YMK.addEventListener('reset', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_GENERIC_EVENT_REMOVE_COLOUR,
        });
      });

      photoSaved = window.YMK.addEventListener('photoSaved', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_GENERIC_EVENT_PHOTO_SAVED,
        });
      });

      cameraFailed = window.YMK.addEventListener('cameraFailed', () => {
        eventHandler({ eventName: VtoEventsNames.VTO_ERROR_CAMERA_FAILED });
      });

      consentUIShowed = window.YMK.addEventListener('consentUIShowed', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_GENERIC_EVENT_CONSENT_SHOWED,
        });
      });

      consentUpdated = window.YMK.addEventListener(
        'consentUpdated',
        (value) => {
          if (value === 'agree') {
            eventHandler({
              eventName: VtoEventsNames.VTO_GENERIC_EVENT_CONSENT_AGREED,
            });
          }
        }
      );

      iconKeyModalCloseBtnClicked = window.YMK.addEventListener(
        'iconKeyModalCloseBtnClicked',
        () => {
          eventHandler({
            eventName: VtoEventsNames.VTO_GENERIC_EVENT_ICON_KEY_VIEW_CLOSED,
          });
        }
      );

      compare = window.YMK.addEventListener('compare', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_PRODUCT_EVENT_SLIDER_COMPARE,
        });
      });

      compareDisabled = window.YMK.addEventListener('compareDisabled', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_PRODUCT_EVENT_SLIDER_COMPARE_CLOSED,
        });
      });

      photoTaken = window.YMK.addEventListener('photoTaken', () => {
        eventHandler({
          eventName: VtoEventsNames.VTO_GENERIC_EVENT_PHOTO_TAKEN,
        });
      });

      noHandDetected = window.YMK.addEventListener('noHandDetected', () => {
        eventHandler({ eventName: VtoEventsNames.VTO_ERROR_NO_HAND_DETECTED });
      });

      noHandDetected = window.YMK.addEventListener(
        'iconKeyModalInfoBtnClicked',
        () => {
          eventHandler({
            eventName: VtoEventsNames.VTO_GENERIC_EVENT_ICON_KEY_BTN_CLICKED,
          });
        }
      );

      splitFourWay = window.YMK.addEventListener('splitFourWay', () => {
        eventHandler({ eventName: VtoEventsNames.SPLIT_FOUR_WAY });
      });

      splitFourWayDisabled = window.YMK.addEventListener(
        'splitFourWayDisabled',
        () => {
          eventHandler({ eventName: VtoEventsNames.SPLIT_FOUR_WAY_CLOSED });
        }
      );

      shareImage = window.YMK.addEventListener('shareImage', (data) => {
        const image = data.image ? data.image : data.base64;

        if (data.type === emailSharingTypes.DOWNLOAD) {
          eventHandler({ eventName: VtoEventsNames.VTO_DOWNLOAD_PICTURE });
          setIsDownloadPictureOpen(image);
        } else {
          eventHandler({ eventName: VtoEventsNames.VTO_SHARE_EMAIL });
          setIsEmailSharingOpen(image);
        }
      });
    }

    return () => {
      if (window && window.YMK) {
        window.YMK.removeEventListener(closed);
        window.YMK.removeEventListener(loaded);
        window.YMK.removeEventListener(launcherPageEntered);
        window.YMK.removeEventListener(opened);
        window.YMK.removeEventListener(cameraOpened);
        window.YMK.removeEventListener(reset);
        window.YMK.removeEventListener(photoSaved);
        window.YMK.removeEventListener(cameraFailed);
        window.YMK.removeEventListener(consentUIShowed);
        window.YMK.removeEventListener(consentUpdated);
        window.YMK.removeEventListener(iconKeyModalCloseBtnClicked);
        window.YMK.removeEventListener(compare);
        window.YMK.removeEventListener(compareDisabled);
        window.YMK.removeEventListener(photoTaken);
        window.YMK.removeEventListener(noHandDetected);
        window.YMK.removeEventListener(splitFourWay);
        window.YMK.removeEventListener(splitFourWayDisabled);
        window.YMK.removeEventListener(shareImage);
      }
    };
  }, [
    vtoScriptLoaded,
    vtoActualProductSku,
    setIsModalOpen,
    setShowStartHero,
    setIsVtoLoaded,
    setIsVtoOpened,
    currentBreakpoint,
    eventHandler,
    setIsEmailSharingOpen,
    setIsDownloadPictureOpen,
  ]);
